import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowLeft, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
    } catch {
      // Always show success to not leak email existence
    }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <Shield className="w-8 h-8 text-[#FF3B30]" />
            <span className="font-heading text-white font-bold text-2xl tracking-tight">RiskCoach<span className="text-[#FF3B30]">.ai</span></span>
          </Link>
          <h1 className="font-heading text-2xl font-bold text-white">Reset Password</h1>
          <p className="text-[#A3A3A3] text-sm mt-2">Enter your email and we'll send a reset link</p>
        </div>

        <div className="bg-[#141414] border border-[#262626] rounded-sm p-6">
          {sent ? (
            <div className="text-center py-4">
              <div className="w-12 h-12 bg-[#22C55E]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-6 h-6 text-[#22C55E]" />
              </div>
              <h2 data-testid="forgot-success" className="text-white font-bold text-lg mb-2">Check Your Email</h2>
              <p className="text-[#A3A3A3] text-sm mb-6">If an account exists for that email, we sent a password reset link.</p>
              <Link to="/login" className="text-[#FF3B30] hover:underline text-sm font-medium">Back to Sign In</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-[#A3A3A3] text-xs tracking-[0.2em] uppercase font-bold block mb-2">Email</label>
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full bg-[#0A0A0A] border border-[#262626] rounded-sm px-4 py-3 text-white placeholder:text-[#737373] focus:outline-none focus:ring-1 focus:ring-[#FF3B30]"
                  placeholder="you@company.com"
                />
              </div>
              <button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={loading}
                className="w-full bg-[#FF3B30] hover:bg-[#D62828] text-white font-bold py-3 rounded-sm transition-colors disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <Link to="/login" className="flex items-center justify-center gap-1 text-[#737373] hover:text-white text-sm transition-colors">
                <ArrowLeft className="w-3.5 h-3.5" /> Back to Sign In
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
